var vars = require('./core');

module.exports = vars.createClass('Line', ['getPointsAtEvent']);



// WEBPACK FOOTER //
// ./src/Scripts/react-chartjs/lib/line.js